export default function BasicCellNull() {
  return null;
}
